import React, { useMemo, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeFullScreenModalAction, openCustomModal } from '../../../../actions/modal';
import Form from '../../../../common/Form';
import Input from '../../../../common/Form/Input';
import { actualValueForDropdown, debounce } from '../../../../utils/common';
import AssetDetails from './AssetDetails';
import { inventory } from '../../../../router/roleWisePageRoute';
import { fullDevice, noDeviceConsumed, partDevice, rmaRequestTypeOptions } from './index';
import { useForm } from 'react-hook-form';
import Select from '../../../../common/Form/Select';
import { useEffect } from 'react';
import DatePicker from '../../../../common/Form/DatePicker';
import { CurrentWarehouseDetail } from './CurrentWarehouseDetail';
import ButtonScogoOrange from '../../../../common/Buttons/ButtonScogoOrange';
import { useState } from 'react';
import scogo_apis from '../../../../scogo_apis';
import Courier from '../../../../components/Inputs/Courier';
import ButtonScogoPrimary from '../../../../common/Buttons/ButtonScogoPrimary';
import ButtonScogoClosedOutlined from '../../../../common/Buttons/ButtonScogoClosedOutlined';
import AddSpareAsset from '../../../Modals/Inventory/AddSpareAsset';
import { CLEAR_CREATED_ASSET_IN_STORE } from '../../../../types/inventory';
import { TicketAgentRole } from '../../TicketController';
import { AddTicketAsset } from '../AddTicketAsset';

export const UpdateRMAForm = ({
    submit,
    defaultValues,
    formName,
    serviceRequest,
    currentMilestone
}) => {
    const dispatch = useDispatch();
    const { formButtonLoading } = useSelector((state) => state.loading);
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);
    const methods = useForm({ defaultValues, mode: 'all' });
    const { courierVendors } = useSelector((state) => state.user);
    const isServiceRequestByIdLoading = useSelector((state) => state.loading.isServiceRequestByIdLoading);
    const { watch } = methods;
    const consumption_type = watch('consumption_type');
    const isNoDeviceConsumendSelected = actualValueForDropdown(consumption_type) === noDeviceConsumed.value;
    const isDevicePartSelected = actualValueForDropdown(consumption_type) === partDevice.value;
    const isFullDeviceSelected = actualValueForDropdown(consumption_type) === fullDevice.value;
    const formRef = useRef(null);
    const createdAsset = useSelector((state) => state.inventory.createdAsset);

    const [checkAssetId, setCheckAssetId] = useState({});

    const onViewAllTicketClick = () => {
        let route = `${inventory.path}?tab=spareAssets&page=1&limit=10&org_id=${serviceRequest.org_id}&status=AVAILABLE`;
        if (currentMilestone?.dispatch_location_id) route = `${route}&selectedWarehouseId=${currentMilestone?.dispatch_location_id}`;
        window.open(`${window.location.origin}${route}`);
    };

    useEffect(() => {
        if (createdAsset && Object.keys(createdAsset).length > 0) {
            Object.entries(createdAsset).forEach(([key, value]) => {
                if (value.serial_number) {
                    methods.setValue(key, value.serial_number, { shouldValidate: true });
                }
            });
            return () => dispatch({ type: CLEAR_CREATED_ASSET_IN_STORE })
        }
    }, [createdAsset]);

    const isHandleHeldingSelected = actualValueForDropdown(watch('courier_vendor_id')) === 'HAND_HOLDING';


    const openAddAssetModal = () => {
        const location = watch('dispatch_location_id');
        const props = { location: location?.location, location_id: actualValueForDropdown(location), serial_number: methods.watch(`assetNumber`), org_id: serviceRequest.org_id, additionalProps: { source: 'update_rma_form', key: `assetNumber` } };
        dispatch(
            openCustomModal({
                heading: 'Add Spare Asset',
                modalWidth: '95rem',
                modalHeight: 'auto',
                modalComponent: <AddSpareAsset {...props} />,
            })
        );
    };

    const isLoggedUserIsScmOrCustomer = useMemo(() => {
        if (!serviceRequest.agents) return false;
        const find = serviceRequest.agents.find(({ agent, role }) => {
            if (agent.id === newLoggedUserData.user.id && role === TicketAgentRole.SCM) return true;
            if (newLoggedUserData.org.id === serviceRequest.helpdesk_id) return true;
            if (agent.id === newLoggedUserData.user.id && role === TicketAgentRole.CLUSTER) return true;
            return false;
        });
        return find ? true : false;
    }, [serviceRequest.agents, serviceRequest.helpdesk_id, newLoggedUserData.user.id, newLoggedUserData.org.id]);

    const isWarehousePrefillAndIsDisabled = useMemo(() => {
        return currentMilestone?.dispatch_location_id && !isLoggedUserIsScmOrCustomer;
    }, [isLoggedUserIsScmOrCustomer, currentMilestone?.dispatch_location_id]);

    const isFaultyDeviveShipToPrefillAndIsDisabled = useMemo(() => {
        return currentMilestone?.receive_location_id && !isLoggedUserIsScmOrCustomer;
    }, [isLoggedUserIsScmOrCustomer, currentMilestone?.receive_location_id]);

    useEffect(() => {
        if (isWarehousePrefillAndIsDisabled) {
            if (currentMilestone?.dispatch_location?.external_id) {
                methods.setValue('dispatch_location_id_field', currentMilestone?.dispatch_location?.external_id);
            }
            methods.setValue('dispatch_location_id', currentMilestone?.dispatch_location_id);
        }
        if (isFaultyDeviveShipToPrefillAndIsDisabled) {
            if (currentMilestone?.receive_location?.external_id) {
                methods.setValue('received_location_id_field', currentMilestone?.receive_location?.external_id);
            }
            methods.setValue('received_location_id', currentMilestone?.receive_location_id);
        }
    }, [isWarehousePrefillAndIsDisabled, isFaultyDeviveShipToPrefillAndIsDisabled, methods, currentMilestone?.receive_location_id, currentMilestone?.dispatch_location_id, currentMilestone?.dispatch_location?.external_id, currentMilestone?.receive_location?.external_id]);

    return (
        <>
            <div className='h-full px-4' style={{ height: 'calc(100% - 8vh)', }}>
                <Form
                    onSubmit={submit}
                    buttonPostion={'justify-end'}
                    methods={methods}
                    submitRef={formRef}
                    className='h-[calc(100% - 10vh)]'
                >
                    <div className='flex gap-8 px-4 pb-3 max-h-max bg-scogolightblue pt-4'>
                        <CurrentWarehouseDetail
                            isLoading={isServiceRequestByIdLoading}
                            serviceRequest={serviceRequest}
                            currentMilestone={currentMilestone}
                            isLoggedUserIsScmOrCustomer={isLoggedUserIsScmOrCustomer}
                            isWarehousePrefillAndIsDisabled={isWarehousePrefillAndIsDisabled}
                            isFaultyDeviveShipToPrefillAndIsDisabled={isFaultyDeviveShipToPrefillAndIsDisabled}
                        />
                        <AssetDetails
                            partcode={currentMilestone?.asset_ledger?.[0]?.asset?.partcode}
                            serial_number={currentMilestone?.asset_ledger?.[0]?.asset?.serial_number}
                            assetTypeTitle={currentMilestone?.asset_ledger?.[0]?.asset?.asset_type?.title}
                            title='Faulty Asset Details'
                            isLoading={isServiceRequestByIdLoading}
                            currentMilestone={currentMilestone}
                        />
                    </div>
                    <div className='flex py-3 px-3 items-end'>
                        <Select
                            className={`w-full ${isNoDeviceConsumendSelected ? 'col-span-3' : ''}`}
                            label='Device Fault Type'
                            name='consumption_type'
                            required
                            options={rmaRequestTypeOptions}
                        />
                        {!isNoDeviceConsumendSelected && (
                            <>
                                {isFullDeviceSelected && (
                                    <div className='relative group w-full'>
                                        <Input
                                            required
                                            className='w-full'
                                            label='AssetId/Serial Number'
                                            name='assetNumber'
                                            type={'text'}
                                            shouldUnregister
                                            validate={{
                                                serialNumberNotInSystem: (value) => {
                                                    if (value === '') return true;
                                                    return new Promise(resolve => {
                                                        const validateSerialNumber = async () => {
                                                            try {
                                                                const response = await scogo_apis.inventory.checkAsset({}, {}, {}, { serial_number: value, org_id: serviceRequest.org_id, working_condition: ['NEW', 'REFURBISHED'] });
                                                                if (response.status === 201 && response.data.data.id) {
                                                                    if (response?.data?.data?.asset_type?.title !== currentMilestone?.asset_ledger?.[0]?.asset?.asset_type?.title) {
                                                                        resolve('Asset Type is different')
                                                                        methods.setValue(`asset_not_found`, true);
                                                                        methods.setValue(`validating`, false);
                                                                        return;
                                                                    }
                                                                    methods.setValue(`fetched_asset_number`, response.data.data.asset_number);
                                                                    methods.setValue(`fetched_serial_number`, response.data.data.serial_number);
                                                                    setCheckAssetId(response.data.data);
                                                                    methods.setValue(`validating`, false);
                                                                    methods.setValue(`asset_not_found`, false);
                                                                    resolve(true);
                                                                } else {
                                                                    methods.setValue(`validating`, false);
                                                                    methods.setValue(`asset_not_found`, true);
                                                                    setCheckAssetId({});
                                                                    resolve("Serial Number doesn't exist in the System.");
                                                                }
                                                            } catch (error) {
                                                                console.error("Error checking serial number:", error);
                                                                methods.setValue(`validating`, false);
                                                                methods.setValue(`asset_not_found`, true);
                                                                setCheckAssetId({});
                                                                resolve(error?.response?.data?.messages?.[0] || 'Error checking serial number');
                                                            }
                                                        };

                                                        try {
                                                            methods.setValue(`validating`, true);
                                                            methods.setValue(`asset_not_found`, false);
                                                            if (!window.debouncedSerialValidation) {
                                                                window.debouncedSerialValidation = debounce((callback) => {
                                                                    callback();
                                                                });
                                                            }
                                                            window.debouncedSerialValidation(validateSerialNumber);
                                                        } catch (error) {
                                                            console.error("Error in validation:", error);
                                                            methods.setValue(`validating`, false);
                                                            methods.setValue(`asset_not_found`, false);
                                                            setCheckAssetId({});
                                                            resolve(error?.response?.data?.messages?.[0] || 'Error validating serial number. Please try again.');
                                                        }
                                                    });
                                                },
                                            }}
                                            renderInfo={<ButtonScogoOrange textOrComponent={'  View All Asset '} onClick={onViewAllTicketClick} />}
                                            labelClassName='flex gap-2'
                                            isLoading={methods.watch(`validating`)}
                                            iconRight={methods.watch(`asset_not_found`) ? { name: 'add', hoverTitle: 'Add Asset', onClick: openAddAssetModal } : null}
                                        />
                                        {(checkAssetId && Object.keys(checkAssetId).length > 0) && (
                                            <div className='absolute left-0 mt-1 w-full bg-white border border-gray-300 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200'>
                                                <div className='p-2'>
                                                    <p><strong>Asset Type:</strong> {checkAssetId.asset_type?.title}</p>
                                                    <p><strong>Serial Number:</strong> {checkAssetId.serial_number}</p>
                                                    <p><strong>Part Code:</strong> {checkAssetId.partcode}</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {isDevicePartSelected && <Input className='w-full' label='Part Name' name='part_name' type={'text'} required shouldUnregister />}
                            </>
                        )}
                    </div>
                    <div><AddConsumablesButton ticket={serviceRequest} /></div>
                    {!isNoDeviceConsumendSelected ? <>
                        <div className='grid grid-cols-3 rows-fr grid-flow-row-dense items-end px-3'>
                            <Courier className='w-full' label='Courier Vendor' name='courier_vendor_id' options={courierVendors} shouldUnregister required={false} prefill={['HAND_HOLDING']} />
                            {!isHandleHeldingSelected ? <>
                                <Input className='w-full' label='Docket Number' name='docket_number' type={'text'} shouldUnregister />
                                <Input className='w-full' label='Courier Cost' name='courier_cost' type={'number'} shouldUnregister />
                            </> : null}
                            {isHandleHeldingSelected && <DatePicker className='w-full' label='ETA' name='eta' shouldUnregister />}
                        </div>
                    </> : null}
                </Form>

            </div >
            <div className='flex gap-2 justify-start pb-8 px-6' style={{ height: '8vh' }}>
                <ButtonScogoPrimary
                    textOrComponent={'Submit'}
                    loading={formButtonLoading[formName]}
                    onClick={() => {
                        formRef?.current?.click();
                    }}
                />
                <ButtonScogoClosedOutlined textOrComponent={'Cancel'} type='button' onClick={() => dispatch(closeFullScreenModalAction())} />
            </div>
        </>
    );
};


const AddConsumablesButton = ({ ticket }) => {
    const dispatch = useDispatch();
    const handleClick = () => {
        let heading = `Add Consumables`;
        let modalComponent = <AddTicketAsset ticket={ticket} isRma />;
        let modalWidth = '60vw',
            modalHeight = 'auto';
        dispatch(openCustomModal({ modalComponent, heading, modalWidth, modalHeight }));
    };

    return <>
        <div className='pb-3 px-6'>
            <ButtonScogoOrange textOrComponent={'Add Consumables'} onClick={handleClick} />
        </div>
    </>
}
